import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class NumaratajKapiListeAPI extends BaseAPI {

  constructor() {
    const baseUrl = environment.API_URL + "NumaratajBagimsizKapListe";
    super(baseUrl);
  }

  geNumaratajKapiListeListe(mahalleKodu: number, caddeSokakKodu?: number) {
    return this.get("", { params: { mahalleKodu: mahalleKodu, caddeSokakKodu: caddeSokakKodu } })

  }
}
export default new NumaratajKapiListeAPI();
